import formExternalLinks from './formExternalLinks';
import formAppWebConfig from './formAppWebConfig';
import formFAQ from './formFAQ';
import formInfoSection from './formInfoSection';

export default {
  title: 'Info Sections and Links',
  attributeName: 'infoSections',
  getURL: 'appId/areaId/infoSections',
  createURL: 'appId/areaId/infoSections',
  updateURL: 'appId/areaId/infoSections',
  removeURL: 'appId/areaId/infoSections',
  sessionParams: ['appId', 'areaId'],
  idUpdate:false,
  formConfig: [
    formInfoSection,
    formExternalLinks,
    formFAQ,
    formAppWebConfig,
  ],
  autoUpdate: false,
};
